export default __webpack_public_path__ + "static/media/logo.fef397d3.png";